import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function CoinsFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22 14.2078V11C22 10.2861 21.5651 9.76519 21.1475 9.4361C20.7186 9.09811 20.16 8.83748 19.5589 8.6371C18.3462 8.23286 16.7344 8 15 8C13.2656 8 11.6538 8.23286 10.4411 8.6371C9.84 8.83748 9.2814 9.09811 8.85254 9.4361C8.43495 9.76519 8 10.2861 8 11V14.1699C8.0482 14.3288 8.17306 14.5159 8.44117 14.7298C8.81278 15.0262 9.37972 15.3041 10.1022 15.54C11.5405 16.0095 13.4029 16.2513 14.9997 16.2513C16.5971 16.2513 18.463 16.0116 19.9045 15.5431C20.6287 15.3077 21.197 15.0301 21.5695 14.7333C21.8182 14.5353 21.9442 14.3598 22 14.2078ZM11.0736 11.4655C10.5969 11.3066 10.2794 11.1392 10.0994 11C10.2794 10.8608 10.5969 10.6934 11.0736 10.5345C12.0325 10.2149 13.4207 9.99999 15 9.99999C16.5793 9.99999 17.9675 10.2149 18.9264 10.5345C19.4031 10.6934 19.7206 10.8608 19.9006 11C19.7206 11.1392 19.4031 11.3066 18.9264 11.4655C17.9675 11.7852 16.5793 12 15 12C13.4207 12 12.0325 11.7852 11.0736 11.4655Z"
				fill="currentColor"
			/>
			<path
				d="M22 16.2537C21.5182 16.5428 20.9568 16.7783 20.3682 16.9696C18.7441 17.4974 16.716 17.7513 14.9997 17.7513C13.2827 17.7513 11.2575 17.495 9.63673 16.9659C9.04579 16.773 8.48247 16.5355 8 16.2441V19C8 19.7139 8.43495 20.2348 8.85254 20.5639C9.2814 20.9019 9.84 21.1625 10.4411 21.3629C11.6538 21.7671 13.2656 22 15 22C16.7344 22 18.3462 21.7671 19.5589 21.3629C20.16 21.1625 20.7186 20.9019 21.1475 20.5639C21.5651 20.2348 22 19.7139 22 19V16.2537Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15 6.5V4C15 3.28612 14.5651 2.76519 14.1475 2.4361C13.7186 2.09811 13.16 1.83748 12.5589 1.6371C11.3462 1.23286 9.73443 1 8 1C6.26557 1 4.65384 1.23286 3.44113 1.6371C2.84 1.83748 2.2814 2.09811 1.85254 2.4361C1.43495 2.76519 1 3.28612 1 4V7.50267C1.03948 7.56548 1.13378 7.68315 1.3587 7.84887C1.71242 8.10949 2.24339 8.3775 2.89196 8.61954C4.16887 9.09609 5.7367 9.41188 6.91313 9.42173C7.20682 8.89684 7.60428 8.51001 7.92408 8.25798C8.54071 7.77201 9.27813 7.44363 9.96679 7.21408C11.3699 6.74638 13.1492 6.5 15 6.5ZM4.07359 4.46553C3.59686 4.30662 3.27937 4.13922 3.09935 4C3.27937 3.86078 3.59686 3.69338 4.07359 3.53447C5.03245 3.21485 6.42072 3 8 3C9.57928 3 10.9675 3.21485 11.9264 3.53447C12.4031 3.69338 12.7206 3.86078 12.9006 4C12.7206 4.13922 12.4031 4.30662 11.9264 4.46553C10.9675 4.78515 9.57928 5 8 5C6.42072 5 5.03245 4.78515 4.07359 4.46553Z"
				fill="currentColor"
			/>
			<path
				d="M1 12.2952V9.39883C1.4101 9.63277 1.8787 9.84245 2.36749 10.0249C3.64395 10.5013 5.19318 10.8409 6.50123 10.9093C6.50041 10.9393 6.5 10.9695 6.5 11V13.9196C5.37069 13.8591 3.98946 13.6045 2.84195 13.2273C2.1797 13.0095 1.63929 12.7651 1.28042 12.5221C1.14328 12.4293 1.05576 12.353 1 12.2952Z"
				fill="currentColor"
			/>
			<path
				d="M1 14.0925V16C1 16.7139 1.43495 17.2348 1.85254 17.5639C2.2814 17.9019 2.84 18.1625 3.44113 18.3629C4.29506 18.6475 5.34685 18.8472 6.5 18.9405V15.4214C5.20769 15.3609 3.66002 15.0752 2.37348 14.6522C1.88511 14.4917 1.41446 14.305 1 14.0925Z"
				fill="currentColor"
			/>
		</svg>
	);
}

CoinsFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default CoinsFilledIcon;
